import {kSystemIcons} from "../../../constants/icons";

export default function GamesLeaveButton({onButtonPressed}) {
    // Used in GamesIndicators to display a leave game
    // button made of icon and text

    // BUILD
    return (
        <div className={`cursor-pointer bg-timerViolet w-[48px] min-w-[48px] h-[48px] min-h-[48px]
                         rounded-full border-[1px] border-violetGrey hover:border-timerBlue
                         flex justify-center items-center text-closeGray hover:text-white`}
             onClick={onButtonPressed}>
            <i className={"material-icons text-[24px]"}>
                {kSystemIcons.close}
            </i>
        </div>
    );
}